import React from 'react';
import { t } from '@lingui/macro';

import { Box, Button } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import { isReactNative } from '@rover/rsdk/src/modules/Env/react';

export interface SaveButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onPress?: () => void;
  label?: string;
}

const SaveButton: React.FC<SaveButtonProps> = ({ disabled, loading, onPress, label = t`Save` }) => {
  const theme = useTheme();

  return (
    <Box
      borderTopWidth={isReactNative() ? '1px' : '0'}
      borderTopColor={theme.colors.border.primary}
      px={isReactNative() ? '5x' : '0x'}
      py="6x"
    >
      <Button
        disabled={disabled}
        loading={loading}
        onPress={onPress}
        variant="primary"
        fullWidth
        size={isReactNative() ? 'default' : 'small'}
      >
        {label}
      </Button>
    </Box>
  );
};

export default SaveButton;
